require("./style.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({params}) {
        this.state = {
            active: false,
            loading: true
        };
        GState.bind(this, [
            'website',
            'tenant',
            'user'
        ]);
    },
    onInput: async function ({params}) {
        const pathname = document.location.pathname;
        if (pathname == this.state.active)
            return;
        if (params.redirectTo) {
            document.location = `/${ !this.state.user || !this.state.user.accounttype ? 'signin?redirectTo=' : '' }${ encodeURIComponent(params.redirectTo) }`;
            return;
        }
        this.state.active = pathname;
        await this.loadPage();
    },
    loadPage: async function (content) {
        if (!this.state.website || isEmpty(this.state.website))
            return;
        if (!this.state.website[this.state.active])
            return document.location = getDefaultPage(this.state.website);
        this.state.loading = true;
        try {
            const response = await fetch(this.state.website[this.state.active]);
            this.currentPage = await response.text();
        } catch (error) {
            debugLog('Failed Fetching Page Content: ', error);
            this.state.active = '404';
        }
        this.state.loading = false;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Website/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_MaintenanceImage = require("public/images/illustration/ongoing-maintenance.jpg"),
    MaintenanceImage = module_MaintenanceImage.default || module_MaintenanceImage,
    Locale_template = require("../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Wrapper_template = require("../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "w-100 vh-100 d-flex align-items-center justify-content-center"
      },
    marko_attrs1 = {
        "class": "w-50 text-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("9401c4"),
    marko_node0 = marko_createElement("br", null, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "5", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "w-100 vh-100 d-flex align-items-center"
      },
    marko_attrs3 = {
        "class": "w-100 text-center"
      },
    marko_attrs4 = {
        "class": "w-100 vh-100 d-flex align-items-center"
      },
    marko_attrs5 = {
        "class": "w-100 text-center"
      },
    marko_node3 = marko_createElement("h1", {
        "class": "error-code font-large-5"
      }, "16", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("404");

function getDefaultPage( pages ){ return pages._default || Object.keys( pages )[0] };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      renderBody: function(out) {
        if ((!state.website) || (!Object.keys(state.website).length)) {
          out.be("div", marko_attrs0, "1", component);

          out.be("div", marko_attrs1, "2", component);

          out.e("img", {
              src: MaintenanceImage,
              alt: "Maintenant",
              "class": "img-fluid w-50"
            }, "3", component, 0);

          out.n(marko_node0, component);

          out.n(marko_node1, component);

          out.be("h2", null, "6", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Website in construction");
              }
            }, out, __component, "7");

          out.ee();

          out.n(marko_node2, component);

          route_link_tag({
              href: "/signin" + (document.search || ""),
              class: "btn btn-primary btn-lg",
              renderBody: function(out) {
                Locale_tag({
                    text: "Sign In"
                  }, out, __component, "10");
              }
            }, out, __component, "9");

          out.ee();

          out.ee();
        } else if (state.loading) {
          out.e("div", marko_attrs2, "11", component, 1)
            .e("div", marko_attrs3, "12", component, 1)
              .e("img", {
                  src: state.tenant.logo,
                  alt: "Logo",
                  style: "width:100px"
                }, "13", component, 0);
        } else if (state.active == "404") {
          out.be("div", marko_attrs4, "14", component);

          out.be("div", marko_attrs5, "15", component);

          out.n(marko_node3, component);

          out.be("h5", null, "17", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Page Not Found");
              }
            }, out, __component, "18");

          out.ee();

          out.ee();

          out.ee();
        } else {
          out.h(component.currentPage, component);
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
